import React from "react";
import { nodejs, flask, postgres, mongodb } from "../../assets";
import "./skills.css";

const Backend = () => {
  return (
    <div className="frontend_section">
      <h1 className="tech__heading">Backend</h1>
      <div className="tech__section">
        <div>
          <img src={nodejs} alt="nodejs" className="tech__logo" />
          <p>NodeJs</p>
        </div>

        {/* <div>
          <img src={springboot} alt="springboot" className="tech__logo" />
          <p>SpringBoot</p>
        </div> */}

        <div>
          <img src={flask} alt="flask" className="tech__logo" />
          <p>Flask</p>
        </div>

        <div>
          <img src={postgres} alt="postgres" className="tech__logo" />
          <p>Postgres</p>
        </div>

        <div>
          <img src={mongodb} alt="mongodb" className="tech__logo" />
          <p>MongoDB</p>
        </div>
      </div>
    </div>
  );
};

export default Backend;
